import classNames from "classnames";
import { Icon } from "../icon/icon";

export const FilterPill = ({
  text,
  onCancel,
  className = "",
}: {
  text: string;
  onCancel: () => void;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "flex items-center gap-1 rounded-full border border-grey-200 bg-white px-3 py-2 text-sm font-bold",
        className,
      )}
    >
      <p>{text}</p>

      <button
        type="button"
        className={classNames("w-fit")}
        onClick={() => {
          onCancel();
        }}
      >
        <Icon
          svg="close-icon"
          width={16}
          height={16}
          className="text-grey-600"
        />
      </button>
    </div>
  );
};
